import { forwardRef, MouseEventHandler, ReactNode, Ref, useEffect } from 'react';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';

// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import CloseIcon from './icons/CloseIconNoBg';
interface Props {
  children: ReactNode;
  show: boolean;
  onClose?: MouseEventHandler<HTMLElement>;
}
interface CrossButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
}
const CrossButton = ({
  onClick
}: CrossButtonProps) => <button aria-label="Close" className="-top-4 right-3 z-10 absolute bg-white p-2 rounded-full" onClick={onClick} data-testid="bottom-drawer-close-button" data-sentry-component="CrossButton" data-sentry-source-file="CenterModal.tsx">
    <CloseIcon className="fill-transparent stroke-neutral-90 w-4 h-4" data-sentry-element="CloseIcon" data-sentry-source-file="CenterModal.tsx" />
  </button>;
const CenterModal = forwardRef(({
  children,
  show,
  onClose
}: Props, ref: Ref<HTMLDivElement>) => {
  const {
    trackCustomEvent
  } = useTriggerEvents();
  useEffect(() => {
    if (show) document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [show]);
  return <section className={`${show ? 'opacity-100 visible' : 'opacity-0 invisible'} fixed inset-0 bg-neutral-90/70 z-[51] transition-visibility duration-100 h-screen w-screen flex items-center justify-center`} onClick={e => {
    e.stopPropagation();
    onClose?.(e);
  }} ref={ref} data-testid="bottom-drawer">
        <section className="relative mx-4 md:mx-8">
          {onClose ? <CrossButton onClick={() => trackCustomEvent(CustomEventTypes.CROSS_ICON)} /> : null}
          <div className="rounded-lg w-full overflow-hidden" onClick={e => e.stopPropagation()}>
            {children}
          </div>
        </section>
      </section>;
});
export default CenterModal;